<template>
<div class="popSendAddr" v-if="centerDialogVisible">
    <el-dialog title="填写发货信息" :visible.sync="centerDialogVisible" width="720px" center>
        <div class="user">
            <div class="box">
                <span>订单号：</span>
                <span>{{popData.orderno}}</span>
            </div>
            <div class="box">
                <span>购买人：</span>
                <img class="img"  :src="popData.customericonurl" alt="" v-if="popData.customericonurl">
                <span>{{popData.customername}}</span>
            </div>
            <div class="box">
                <span>支付金额：</span>
                <span>￥{{popData.finalpaymoney}}</span>
            </div>
            <div class="box">
                <span>订单时间：</span>
                <span>{{popData.datetime}}</span>
            </div>
            <div class="box">
                <span>收货姓名：</span>
                <span>{{popData.shipname}}</span>
            </div>
            <div class="box">
                <span>收货号码：</span>
                <span>{{popData.shiptel}}</span>
            </div>
            <div class="fullbox">
                <span class="name">收货地址：</span>
                <span>{{popData.shipaddress}}</span>
            </div>
        </div>
        <div class="ship">
            <el-form :model="ship" :rules="rules" ref="formName" label-width="120px" class="demo-item" label-position="left" size="mini">
                <el-form-item label="快递公司名称：" prop="shipcompanyname">
                    <el-input v-model="ship.shipcompanyname" placeholder="请输入快递公司名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="快递单号："  prop="shipno">
                    <el-input v-model="ship.shipno" placeholder="请输入快递单号" clearable></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="send">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {uploadOrderShipInfo} from 'api/nationalDistribution'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'popSendAddr',
    data() {
        return {
            centerDialogVisible: false,
            ship: {
                eventinnerid: '',
                orderno: '',
                shipcompanyname: '',
                shipno: ''
            },
            rules: {
                shipcompanyname: [
                    {required: true, message: '请输入快递公司名称', trigger: 'blur'}
                ],
                shipno: [
                    {required: true, message: '请输入快递单号', trigger: 'blur'}
                ]
            }
        }
    },
    props: ['popData'],
    mounted() {
    },
    methods: {
        open(eventinnerid, obj) {
            this.ship.eventinnerid = eventinnerid
            this.ship.orderno = obj.orderno
            this.centerDialogVisible = true
        },
        send() {
            this.$refs.formName.validate((valid) => {
                if (valid) {
                    this.$confirm('确定要提交配送信息吗？', '提交资料', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this._send()
                    }).catch(() => {})
                }
            })
        },
        _send() {
            this.setLoading(true)
            uploadOrderShipInfo({
                data: this.ship,
                success: data => {
                    this.setLoading(false)
                    this.$emit('getList')
                    this.centerDialogVisible = false
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.popSendAddr {
    .user{
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        .box{
            width: 50%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .fullbox{
            padding: 15px 0;
            line-height: 20px;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            .name{
                width: 120px;
            }
        }
    }
}
</style>
